const BASE_URL = process.env.REACT_APP_BASE_URL || '';

async function fetchWithTimeout(url, options = {}, timeout = 10000) {
  const controller = new AbortController();
  const id = setTimeout(() => controller.abort(), timeout);
  try {
    const res = await fetch(url, { signal: controller.signal, ...options });
    return res;
  } finally {
    clearTimeout(id);
  }
}

export async function getItemsByGenre(genre, timeout = 10000) {
  const url = `${BASE_URL}/api/items/genre/${encodeURIComponent(genre)}`;
  console.debug('[itemsApi] fetching', url, 'timeout=', timeout);
  let res;
  try {
    res = await fetchWithTimeout(url, { method: 'GET' }, timeout);
  } catch (err) {
    if (err.name === 'AbortError') {
      throw new Error('Request timed out');
    }
    throw err;
  }

  if (!res.ok) {
    const text = await res.text();
    throw new Error(`Failed to fetch items: ${res.status} ${text}`);
  }
  const data = await res.json();
  return data;
}

export async function getFilters( timeout = 10000) {
  const url = `${BASE_URL}/api/filters`;
  console.debug('[itemsApi] fetching filters', url, 'timeout=', timeout);
  let res;
  try {
    res = await fetchWithTimeout(url, { method: 'GET' }, timeout);
  } catch (err) {
    if (err.name === 'AbortError') {
      throw new Error('Request timed out');
    }
    throw err;
  }

  if (!res.ok) {
    const text = await res.text();
    throw new Error(`Failed to fetch filters: ${res.status} ${text}`);
  }
  const data = await res.json();
  return data;
}
export default { getItemsByGenre, getFilters };
